var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SpeedDial, SpeedDialAction } from '@mui/material';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { Pause, PlayArrow } from '@mui/icons-material';
import icons from '../utils/Icons';
var actions = [
    { icon: _jsx(EditTwoToneIcon, {}), name: 'Edit', onClick: function () { return console.log('Edit'); } },
    { icon: _jsx(DeleteTwoToneIcon, {}), name: 'Delete', onClick: function () { return console.log('Delete'); } },
];
var CustomSpeedDial = function (_a) {
    var onEditClick = _a.onEditClick, onDeleteClick = _a.onDeleteClick, deleted = _a.deleted, onUpdateStausClick = _a.onUpdateStausClick;
    var actions = __spreadArray(__spreadArray([
        { icon: _jsx(EditTwoToneIcon, {}), name: 'Edit', onClick: onEditClick },
        { icon: _jsx(DeleteTwoToneIcon, {}), name: 'Delete', onClick: onDeleteClick }
    ], (deleted === 0 ? [{ icon: _jsx(Pause, {}), name: 'Pause', onClick: onUpdateStausClick }] : []), true), (deleted === 5 ? [{ icon: _jsx(PlayArrow, {}), name: 'Play', onClick: onUpdateStausClick }] : []), true);
    return (_jsx(SpeedDial, { ariaLabel: "SpeedDial basic example", color: "error", style: { color: 'red' }, sx: { position: 'absolute', bottom: 100, right: 16 }, icon: _jsx("img", { src: icons.closeWhite, alt: "Delete Button" }), FabProps: {
            sx: { bgcolor: 'error.main', '&:hover': { bgcolor: 'error.dark' } },
        }, children: actions.map(function (action) { return (_jsx(SpeedDialAction, { icon: action.icon, tooltipTitle: action.name, onClick: action.onClick }, action.name)); }) }));
};
export default CustomSpeedDial;
